import { render, staticRenderFns } from "./order.vue?vue&type=template&id=47239b79&scoped=true&"
import script from "./order.vue?vue&type=script&lang=ts&"
export * from "./order.vue?vue&type=script&lang=ts&"
import style0 from "./order.vue?vue&type=style&index=0&id=47239b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47239b79",
  null
  
)

export default component.exports